import { render, staticRenderFns } from "./PortalsEdit.vue?vue&type=template&id=2a7e42a0"
import script from "./PortalsEdit.vue?vue&type=script&lang=js"
export * from "./PortalsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports